import { UserProfile } from './type';
import firestore from '@/firebase/db';

export const isUserBuyer = (userRole: string | null | undefined) =>
  userRole?.toLowerCase() === 'buyer' || userRole?.toLowerCase() === 'general user';
export const isUserRealtor = (userRole: string | null | undefined) => userRole?.toLowerCase() === 'realtor';
export const isUserAdmin = (userRole: string | null | undefined) => userRole?.toLowerCase() === 'admin';
export const isUserGeneral = (userRole: string | null | undefined) => userRole?.toLowerCase() === 'general user';
export const isUserBlogWriter = (userProfile: UserProfile | null | undefined) => userProfile?.isBlogWriter === true;
export const isUserSuperAdmin = (userProfile: UserProfile | null | undefined) => userProfile?.isSuperAdmin === true;

/**
 * Retrieves the profile picture URL for a user by their email address
 * @param email - The email address of the user
 * @returns Promise<string | null> - The profile picture URL or null if not found
 */
export async function getProfilePictureByEmail(email: string): Promise<string | null> {
  try {
    // First get the user's profile to get their userId
    const userProfile = await firestore.get("profile", {
      where: [['email', '==', email]],
      limit: 1
    });

    if (!userProfile || userProfile.length === 0) {
      return null;
    }

    // Then get their profile photo using their userId
    const photos = await firestore.get("profile_photos", {
      where: [['userId', '==', userProfile[0].userId]],
      limit: 1
    });

    if (photos && photos.length > 0) {
      return photos[0].photoURL;
    }

    return null;
  } catch (error) {
    console.warn('Could not fetch user profile picture:', error);
    return null;
  }
}